import { Box, Slider, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { sanitizeNumeric } from '../utils/utilsT';

function valuetext(value: number) {
    return `${value}°C`;
}
interface PropsValueLabelComponentT {
    children: React.ReactElement;
    open: boolean;
    value: number;
}
const ValueLabelComponent = (props: PropsValueLabelComponentT) => {
    const { children, open, value } = props;
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
}

export interface SliderRecordValues {
    startTime?: number
    endTime?: number
}
export type ISliderRecordCallProps = {
    duration: number
    values: SliderRecordValues
    onChangeValues(fields: SliderRecordValues): void
    disabled?: boolean
}

const SliderRecordCall: React.FC<ISliderRecordCallProps> = (props) => {
    const [position, setPosition] = React.useState<number[]>([0, props.duration]);

    // console.log("duration",props.duration)

    React.useEffect(() => {
        let clonePoistion = []
        clonePoistion[0] = sanitizeNumeric(props?.values?.startTime)
        clonePoistion[1] = sanitizeNumeric(props?.values?.endTime)
        setPosition(clonePoistion)
    }, [props.values]);

    const handleChangeSlider = (event: Event, newValue: number | number[]) => {
        const values = newValue as number[]
        setPosition(values);
        onChangeValues(values);
    };

    const onChangeValues = (newValue: number[]) => {
        let fields: SliderRecordValues = {
            startTime: newValue[0],
            endTime: newValue[1],
        }
        props.onChangeValues(fields)
    }

    function formatDuration(value: number) {
        const minute = Math.floor(value / 60);
        const secondLeft = value - minute * 60;
        return `${minute}:${secondLeft < 10 ? `0${secondLeft}` : secondLeft}`;
    }
    return (
        <Stack direction={"column"}>
            <div className='d-flex justify-content-center ' style={{ gap: 20 }}>
                {/* <div className='d-flex' >
                    <span  >Start Time</span>
                </div> */}
                <div className='d-flex flex-fill' >
                    <Slider
                        disabled={props?.disabled}
                        // aria-label="time-indicator"
                        min={0}
                        step={1}
                        max={props.duration}
                        value={position}
                        getAriaValueText={(value: number) => {
                            return formatDuration(value);
                        }}
                        valueLabelFormat={formatDuration}
                        onChange={handleChangeSlider}
                        valueLabelDisplay="auto"

                        // ValueLabelComponent={ValueLabelComponent}
                        // getAriaValueText={valuetext}
                        disableSwap
                        // aria-label="custom thumb label"
                        aria-labelledby="non-linear-slider"
                    />
                </div>
                {/* <div className='d-flex' >
                    <span >End Time </span>
                </div> */}
            </div>
            <Box
                // className='mt-1'
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // mt: -2,
                }} >
                <span>{formatDuration(position[0])}</span>
                <span>-{formatDuration(position[1])}</span>
            </Box>
        </Stack>
    );
}

export default SliderRecordCall